export default "__VITE_ASSET__C6SCVsK3__"